import React, { useEffect } from 'react'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAppSelector } from '../../../../store/hooks'
import { createState, IntegrationServiceId } from '../../../../common/integrations'
import { getIntegrationRedirectUri } from '../../utils'

interface BaseSSOIntegrationConnectorProps {
  serviceId: IntegrationServiceId
  startConnect: boolean
  onConnected: () => void
  stateStep: string | null
}

export const BaseSSOIntegrationConnector: React.FC<BaseSSOIntegrationConnectorProps> = ({ serviceId, startConnect, onConnected, stateStep }) => {
  const accountId = useAppSelector(selectAccountId)

  useEffect(() => {
    if (startConnect && accountId) {
      const redirectUri = getIntegrationRedirectUri(serviceId)
      const state = redirectUri ? createState(window.location.origin + '/dashboard/account/integration-settings/integrations', stateStep) : createState()
      const url = `${import.meta.env.REACT_APP_IAM_API_BASE_URL}/accounts/${accountId}/user-integrations/${serviceId}/enable?redirect_uri=${redirectUri}&state=${state}`
      window.location.href = url

      onConnected()
    }
  }, [startConnect, accountId, serviceId, onConnected, stateStep])

  return null
}
